import DeleteAreaContainer from "./DeleteAreaContainer";
export default DeleteAreaContainer;
